module.exports = function() {
  return new Worker(__webpack_public_path__ + "1ebdb6411cf7bd120c81.worker.js");
};